/**
 * NgbModal `size: 'zip'` adds classes `modal-dialog modal-zip` on the dialog element.
 * Dialog width is defined globally in styles.css; this toggles a wider variant when
 * the Mix & Match selection side panel is open (replaces legacy inline width/maxWidth).
 */
export function setModalZipMixMatchSidePanelOpen(open: boolean): void {
	const nodes = document.querySelectorAll<HTMLElement>('.modal-dialog.modal-zip');
	nodes.forEach((el) => {
		el.style.removeProperty('width');
		el.style.removeProperty('max-width');
		el.style.removeProperty('maxWidth');
		el.style.removeProperty('transition');
		el.classList.toggle('modal-zip--with-selection', open);
	});
}
